const { setInitialised, useArrows } = window.BAO.Carousel.plugins

export class CartRecommendations extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )

    if (this.isCartEmpty()) return

    this.render()
  }

  disconnectedCallback () {
    window.BAO.eventBus.removeEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )

    super.disconnectedCallback()
  }

  onCartChanged () {
    window.requestAnimationFrame(() => {
      if (this.isCartEmpty()) {
        this.hideRecommendations()
        return
      }

      if (this.isConnected) {
        this.render()
      }
    })
  }

  isCartEmpty () {
    const cartItems = document.querySelector('cart-items')

    return (
      cartItems?.classList.contains('crt-Items-empty') ||
      Boolean(cartItems?.querySelector('.crt-Items_Empty'))
    )
  }

  hideRecommendations () {
    document.querySelectorAll('.crt-Recommendations').forEach(container => {
      container.innerHTML = ''
    })
  }

  render () {
    if (this.isCartEmpty()) {
      this.hideRecommendations()
      return
    }

    if (!this.url) return

    fetch(this.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div')
        html.innerHTML = text

        const recommendationsCheck = html.querySelector(
          '[data-cart-recommendations-carousel-el="slides"]',
        )
        const recommendations = html.querySelector('cart-recommendations')
        const hasItems =
          recommendations && recommendationsCheck?.innerHTML.trim().length

        if (hasItems) {
          document
            .querySelectorAll('.crt-Recommendations')
            .forEach(container => {
              container.innerHTML = recommendations.innerHTML
            })
        } else {
          this.hideRecommendations()
        }
      })
      .catch(e => {
        console.error(e)
      })
  }

  get url () {
    return this.dataset.url
  }
}

if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations)
}

class CartRecommendationsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.render()
  }

  disconnectedCallback () {
    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = null
    }

    document.body.style.removeProperty('--Carousel_Height')

    super.disconnectedCallback()
  }

  setupListeners () {
    super.setupListeners()
    window.addEventListener('resize', () => this.onResize())
  }

  render () {
    if (!this.els?.slide?.exists) return

    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = null
    }

    this.carousel = this.setupCarousel()
    this.updateCarouselHeight()
  }

  onResize () {
    if (this.carousel) {
      this.carousel.update()
      this.updateCarouselHeight()
    }
  }

  setupCarousel () {
    this.carousel = new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1.8,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.2,
              spacing: 10,
            },
          },
        },
        breakpoints: {
          '(min-width: 1301px)': {
            slides: {
              perView: 2.6,
              spacing: 10,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
          hideArrows: true,
        }),
      ],
    )

    this.carousel.on('created', () => {
      this.updateCarouselHeight()
    })

    this.carousel.on('updated', () => {
      this.updateCarouselHeight()
    })

    return this.carousel
  }

  updateCarouselHeight () {
    if (window.innerWidth <= 769) {
      requestAnimationFrame(() => {
        const height = this.offsetHeight
        document.body.style.setProperty('--Carousel_Height', `${height}px`)
      })
    } else {
      document.body.style.removeProperty('--Carousel_Height')
    }
  }
}

if (!customElements.get('cart-recommendations-carousel')) {
  customElements.define(
    'cart-recommendations-carousel',
    CartRecommendationsCarousel,
  )
}
